import { render, staticRenderFns } from "./AccountFiltersManageView.vue?vue&type=template&id=2a066172&"
import script from "./AccountFiltersManageView.vue?vue&type=script&lang=js&"
export * from "./AccountFiltersManageView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a066172')) {
      api.createRecord('2a066172', component.options)
    } else {
      api.reload('2a066172', component.options)
    }
    module.hot.accept("./AccountFiltersManageView.vue?vue&type=template&id=2a066172&", function () {
      api.rerender('2a066172', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/email/account/AccountFiltersManageView.vue"
export default component.exports